import {
  Box,
  Button,
  Menu,
  MenuItem,
  Stack,
  IconButton,
  useMediaQuery,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Drawer,
  alpha,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";


/* ================= THEME COLORS ================= */
const THEME_COLOR = "#1e5bff";
const THEME_BG = alpha("#1e5bff", 0.08);

/* ================= MENU CONFIG ================= */
export const NAV_MENUS = [
  {
    id: "about",
    label: (lang) => (lang === "mr" ? "सीडीएमपी बद्दल" : "About CDMP 2026"),
    items: [
      {
        id: 1,
        label: (lang) => (lang === "mr" ? "विहंगावलोकन आणि उद्दिष्ट" : "Overview and Objective"),
        path: "/overview",
      },
      {
        id: 2,
        label: (lang) =>
          lang === "mr" ? "सीडीएमपी दस्तऐवज" : "CDMP Documents",
        path: "/cdmp/documents",
      },
    ],
  },
  {
    id: "risk",
    label: (lang) =>
      lang === "mr"
        ? "असुरक्षितता व जोखीम मूल्यांकन"
        : "Vulnerability & Risk Assessment",
    items: [
      {
        id: 3,
        label: (lang) => (lang === "mr" ? "शहर प्रोफाइल" : "City Profile"),
        path: "/cdmp/city-profile",
      },
      {
        id: 4,
        label: (lang) => (lang === "mr" ? "धोका प्रोफाइल" : "Hazard Profile"),
        path: "/cdmp/hazard-profile",
      },
      {
        id: 5,
        label: (lang) =>
          lang === "mr" ? "असुरक्षितता मूल्यांकन" : "Vulnerability Assessment",
        path: "/cdmp/vulnerability-assessment",
      },
      {
        id: 6,
        label: (lang) =>
          lang === "mr"
            ? "जोखीम नकाशांकन व विश्लेषण"
            : "Risk Mapping and Analysis",
        path: "/cdmp/risk-mapping-and-analysis",
      },
    ],
  },
  {
    id: "institutional",
    label: (lang) => (lang === "mr" ? "संस्थात्मक रचना" : "Institutional"),
    items: [
      {
        id: 7,
        label: (lang) =>
          lang === "mr" ? "संस्थात्मक रचना" : "Institutional Structure",
        path: "/cdmp/institutional-structure",
      },
      // {
      //   id: 8,
      //   label: (lang) =>
      //     lang === "mr" ? "संघटनेची रचना" : "Organisation structure",
      //   path: "/cdmp/organisation-structure-record",
      // },
    ],
  },
  {
    id: "preventionAndMitigation",
    label: (lang) =>
      lang === "mr"
        ? "प्रतिबंध व शमन"
        : "Prevention & Mitigation",

    items: [
      {
        id: 20,
        label: (lang) =>
          lang === "mr"
            ? "स्ट्रक्चरल आणि नॉन-स्ट्रक्चरल उपाययोजना"
            : "Structural & Non-Structural Measures",
        path: "/cdmp/structural-and-non-structural-measures",
      },

      {
        id: 21,
        label: (lang) =>
          lang === "mr"
            ? "क्षमता निर्माण आणि प्रशिक्षण"
            : "Capacity Building & Training",
        path: "/cdmp/capacity-building-and-training",
      },

      {
        id: 22,
        label: (lang) =>
          lang === "mr"
            ? "मानक कार्यपद्धती"
            : "Standard Operating Procedures",
        path: "/cdmp/standard-operaating-procedures",
      },
    ],
  },
  {
    id: "preparedness",
    label: (lang) => (lang === "mr" ? "तयारी" : "Preparedness"),
    items: [
      {
        id: 9,
        label: (lang) =>
          lang === "mr"
            ? "प्रतिबंध व शमन उपाययोजना"
            : "Preparedness Measures",
        path: "/cdmp/preparedness-measures",
      },
      // {
      //   id: 15,
      //   label: (lang) =>
      //     lang === "mr"
      //       ? "स्ट्रक्चरल आणि नॉन-स्ट्रक्चरल उपाययोजना"
      //       : "Structural and non-structural measures",
      //   path: "/cdmp/structural-and-non-structural-measures",
      // },
      // {
      //   id: 16,
      //   label: (lang) =>
      //     lang === "mr"
      //       ? "क्षमता निर्माण आणि प्रशिक्षण"
      //       : "Capacity building and training",
      //   path: "/cdmp/capacity-building-and-training",
      // },
      // {
      //   id: 17,
      //   label: (lang) =>
      //     lang === "mr"
      //       ? "मानक ऑपरेटिंग प्रक्रिया"
      //       : "Standard operating procedures",
      //   path: "/cdmp/standard-operaating-procedures",
      // },
    ],
  },
  {
    id: "recovery",
    label: (lang) => (lang === "mr" ? "पुनर्प्राप्ती" : "Recovery"),
    items: [
      {
        id: 11,
        label: (lang) =>
          lang === "mr" ? "प्रतिसाद आणि मदत कार्ये" : "Response And Relief Operations",
        path: "/cdmp/response-and-relief-operations",
      },
      {
        id: 18,
        label: (lang) =>
          lang === "mr" ? "पुनर्रचना आणि पुनर्वसन" : "Reconstruction And Rehabilitation",
        path: "/cdmp/reconstruction-and-rehabilitation",
      },
    ],
  },
  {
    id: "contact",
    label: (lang) => (lang === "mr" ? "संपर्क" : "Contact"),
    items: [
      // {
      //   id: 12,
      //   label: (lang) =>
      //     lang === "mr" ? "विभाग संपर्क" : "Department Contacts",
      //   path: "/cdmp/department-contacts",
      // },
      {
        id: 13,
        label: (lang) =>
          lang === "mr" ? "आपत्कालीन हेल्पलाइन" : "Emergency Helplines",
        path: "/cdmp/contact-information",
      },
      {
        id: 14,
        label: (lang) =>
          lang === "mr" ? "अभिप्राय व तक्रारी" : "Feedback and Grievances",
        path: "/grievance/submit",
      },
      {
        id: 18,
        label: (lang) =>
          lang === "mr"
            ? "राष्ट्रीय आपत्ती व्यवस्थापन संस्था (NIDM)"
            : "NIDM",
        href: "https://nidm.gov.in/",
        external: true,
        target: "_blank", // Added to open in new tab
        rel: "noopener noreferrer", // Added for security
      },
      {
        id: 19,
        label: (lang) =>
          lang === "mr"
            ? "राष्ट्रीय आपत्ती व्यवस्थापन केंद्र (NMC)"
            : "NMC",
        href: "https://www.nmcnagpur.gov.in/",
        external: true,
        target: "_blank", // Added to open in new tab
        rel: "noopener noreferrer", // Added for security
      },
    ],
  },
];


const ActionHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [mobileDrawer, setMobileDrawer] = useState(false);
  const { language } = useLanguage();
  const [connectDiary, setConnectDiary] = useState(null);

  const isActivePath = (path) => location.pathname === path;

  const isParentActive = (menu) =>
    menu.items.some((item) => location.pathname.startsWith(item.path));

  const openMenu = (e, menu) => {
    setAnchorEl(e.currentTarget);
    setActiveMenu(menu);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };

  const handleMenuItemClick = (item) => {
    console.log("handleMenuItemClick", item);

    if (item.external && item.href) {
      window.open(item.href, item.target || "_blank", item.rel || "noopener,noreferrer");
    } else if (item.path) {
      navigate(item.path);
    }
    closeMenu();
    setMobileDrawer(false);
  };


  // const handleMenuItemClick = (path) => {
  //   navigate(path);
  //   closeMenu();
  //   setMobileDrawer(false);
  // };

  // Calculate top position based on screen size
  const getTopPosition = () => {
    return {
      xs: 104, // TopNavbar(48) + Navbar(56)
      sm: 112, // TopNavbar(48) + Navbar(64)
      md: 138, // TopNavbar(48) + Navbar(90)
    };
  };

  const departmentContactsPath =
    NAV_MENUS.find((menu) => menu.id === "contact")
      ?.items.find((item) => item.path === "/cdmp/contact-information")?.path ||
    "/cdmp/contact-information";

  /* ===================== DESKTOP ===================== */
  if (!isMobile) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: getTopPosition(),
          width: "100%",
          bgcolor: "#ffffff",
          borderBottom: "1px solid #e0e0e0",
          zIndex: 1100,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          // height: 48,
          minHeight: 48,
          height: "auto",
          py: 0.5,
        }}
      >
        <Box
          sx={{
            px: { xs: 2, md: 2, lg: 2 },
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            // overflowX: "auto",
            overflowY: "hidden",
            whiteSpace: "nowrap",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
          }}
          className="navBarMenus"
        >
          <Stack
            direction="row"
            spacing={1.6}
            sx={{
              mx: "auto",
              alignItems: "center",
            }}
          >
            {/* HOME */}
            <Button
              onClick={() => navigate("/")}
              disableRipple
              sx={{
                textTransform: "none",
                fontWeight: isActivePath("/") ? 700 : 500,
                color: isActivePath("/") ? THEME_COLOR : "#000",
                backgroundColor: isActivePath("/") ? THEME_BG : "transparent",
                // fontSize: { md: "0.85rem", lg: "0.9rem" },
                fontSize: {
                  md: "0.78rem",
                  lg: "0.85rem",
                  xl: "0.9rem",
                },
                px: { md: 1.5, lg: 2 },
                py: "6px",
                minWidth: "auto",
                minHeight: 32,
                whiteSpace: "nowrap",
                border: "1px solid transparent", // Prevents movement
                transition: "none", // Removes hover transition
                "&:hover": {
                  backgroundColor: THEME_BG,
                  border: "1px solid transparent", // Maintains same border
                },
              }}
            >
              {language === "mr" ? "मुख्यपृष्ठ" : "Home"}
            </Button>

            {/* MAIN MENUS */}
            {NAV_MENUS.map((menu) => (
              <Button
                key={menu.id}
                endIcon={<KeyboardArrowDownIcon sx={{ fontSize: "1rem" }} />}
                onMouseEnter={(e) => openMenu(e, menu)}
                onClick={(e) => openMenu(e, menu)}
                disableRipple
                sx={{
                  textTransform: "none",
                  fontWeight: 500, // 🔥 FIXED weight (no layout shift)
                  color: isParentActive(menu) ? THEME_COLOR : "#000",
                  backgroundColor: isParentActive(menu) ? THEME_BG : "transparent",
                  // fontSize: { md: "0.85rem", lg: "0.9rem" },
                  fontSize: {
                    md: "0.78rem",
                    lg: "0.85rem",
                    xl: "0.9rem",
                  },
                  // px: { md: 2, lg: 2.5 }, // fixed padding
                  px: { md: 1, lg: 1, xl: 2 },
                  py: "6px",
                  // minWidth: 110, // 🔥 prevents width jump
                  minWidth: "fit-content",
                  maxWidth: 220,
                  height: 32, // fixed height
                  whiteSpace: "nowrap",
                  border: "none", // 🔥 remove border completely
                  borderRadius: 1,
                  transition: "background-color 0.2s ease, color 0.2s ease",
                  "&:hover": {
                    backgroundColor: THEME_BG,
                  },
                }}

              >
                {menu.label(language)}
              </Button>
            ))}
          </Stack>
        </Box>

        {/* DESKTOP DROPDOWN */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          disableScrollLock
          keepMounted
          MenuListProps={{
            onMouseLeave: closeMenu,
            sx: { py: 0.5 }
          }}
          PaperProps={{
            sx: {
              mt: 0.5,
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              minWidth: 220,
            },
          }}
        >
          {activeMenu?.items.map((item) => (
            <MenuItem
              key={item.id}
              onClick={() => handleMenuItemClick(item)}
              // onClick={() => handleMenuItemClick(item.path)}
              disableRipple
              sx={{
                fontWeight: isActivePath(item.path) ? 700 : 400,
                color: isActivePath(item.path) ? THEME_COLOR : "#000",
                backgroundColor: isActivePath(item.path) ? THEME_BG : "transparent",
                py: 1.2,
                px: 2,
                fontSize: "0.9rem",
                border: "1px solid transparent", // Prevents movement
                transition: "none", // Removes hover transition
                "&:hover": {
                  backgroundColor: THEME_BG,
                  border: "1px solid transparent", // Maintains same border
                },
              }}
            >
              {item.label(language)}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  /* ===================== MOBILE ===================== */
  return (
    <Box
      sx={{
        position: "fixed",
        top: { xs: 104, sm: 112 },
        width: "100%",
        bgcolor: "#ffffff",
        borderBottom: "1px solid #e0e0e0",
        zIndex: 1100,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        height: 48,
      }}
    >

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          px: 2,
          gap: 1,
        }}
      >
        {/* LEFT: MENU TITLE */}
        {/* <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.95rem",
            color: "#333",
          }}
        >
          {language === "mr" ? "मेनू" : "Menu"}
        </Typography> */}

        {/* CENTER: CONNECT DIARY (MOBILE ONLY) */}
        <Button
          onClick={() => navigate(departmentContactsPath)}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.8rem",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            background: "linear-gradient(135deg, #ff9800, #f57c00)",
            color: "#fff",
            whiteSpace: "nowrap",
            boxShadow: "0 3px 10px rgba(245,124,0,0.35)",
            "&:hover": {
              background: "linear-gradient(135deg, #fb8c00, #ef6c00)",
            },
          }}
        >
          {language === "mr" ? "कनेक्ट डायरी" : "Connect Diary"}
        </Button>

        {/* RIGHT: MENU ICON */}
        <IconButton
          onClick={() => setMobileDrawer(true)}
          sx={{
            color: THEME_COLOR,
            "&:hover": { bgcolor: THEME_BG },
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>

      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          px: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.95rem",
            color: "#333",
          }}
        >
          {language === "mr" ? "मेनू" : "Menu"}
        </Typography>

        <IconButton
          onClick={() => setMobileDrawer(true)}
          sx={{
            color: THEME_COLOR,
            "&:hover": { bgcolor: THEME_BG },
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box> */}

      <Drawer
        anchor="left"
        open={mobileDrawer}
        onClose={() => setMobileDrawer(false)}
        PaperProps={{
          sx: {
            width: 300,
            pt: 1,
          },
        }}
      >
        {/* DRAWER HEADER */}
        <Box sx={{ p: 2, borderBottom: "1px solid #f0f0f0", mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: THEME_COLOR }}>
            {language === "mr" ? "नागपूर डीएम" : "Nagpur DM"}
          </Typography>
        </Box>

        {/* HOME */}
        <MenuItem
          onClick={() => handleMenuItemClick("/")}
          disableRipple
          sx={{
            fontWeight: isActivePath("/") ? 700 : 500,
            color: isActivePath("/") ? THEME_COLOR : "#000",
            backgroundColor: isActivePath("/") ? THEME_BG : "transparent",
            py: 1.5,
            px: 3,
            mb: 0.5,
            border: "1px solid transparent",
            transition: "none",
            "&:hover": {
              backgroundColor: THEME_BG,
              border: "1px solid transparent",
            },
          }}
        >
          {language === "mr" ? "मुख्यपृष्ठ" : "Home"}
        </MenuItem>

        {/* MOBILE MENUS */}
        {NAV_MENUS.map((menu) => (
          <Accordion
            key={menu.id}
            disableGutters
            elevation={0}
            sx={{
              borderBottom: "1px solid #f0f0f0",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                px: 3,
                py: 1,
                minHeight: 48,
                border: "1px solid transparent",
                "&:hover": {
                  backgroundColor: THEME_BG,
                },
              }}
            >
              <Typography
                fontWeight={isParentActive(menu) ? 700 : 500}
                color={isParentActive(menu) ? THEME_COLOR : "#000"}
                fontSize="0.95rem"
              >
                {menu.label(language)}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 0, bgcolor: "#fafafa" }}>
              {menu.items.map((item) => (
                <MenuItem
                  key={item.id}
                  onClick={() => handleMenuItemClick(item)}
                  // onClick={() => handleMenuItemClick(item.path)}
                  disableRipple
                  sx={{
                    pl: 5,
                    py: 1.5,
                    fontWeight: isActivePath(item.path) ? 700 : 400,
                    color: isActivePath(item.path) ? THEME_COLOR : "#000",
                    backgroundColor: isActivePath(item.path) ? THEME_BG : "transparent",
                    borderBottom: "1px solid #f0f0f0",
                    borderLeft: "1px solid transparent",
                    borderRight: "1px solid transparent",
                    borderTop: "1px solid transparent",
                    fontSize: "0.9rem",
                    transition: "none",
                    "&:hover": {
                      backgroundColor: THEME_BG,
                      border: "1px solid transparent",
                    },
                  }}
                >
                  {item.label(language)}
                </MenuItem>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </Drawer>
    </Box>
  );
};

export default ActionHeader;